import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const RoleAvatarColorCircle = styled(Box).attrs(({ bg }) => ({
  bg: bg,
  width: 16,
  height: 16,
}))`
  border-radius: 50%;
`;
export const AvatarContainer = styled(Box)`
  flex: 0 0 auto;
`;
export const BasePrimaryText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})``;
export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  display: flex;
  width: 13px;
  height: 13px;
  margin: 0 10px 0 0;
  flex: 0 0 auto;
`;
